// Dependencies
import { FC } from "react";

// Components
import UserInfo from "./UserInfo";
import MenuItem from "./MenuItem";
import LogoutMenu from "./LogoutMenu";
import { List } from "@mui/material";

// Icons
import { ReactComponent as HelpIcon } from "~/assets/icons/help.svg";
import { ReactComponent as LogoutIcon } from "~/assets/icons/logout.svg";
import { ReactComponent as BudgetsIcon } from "~/assets/icons/budget.svg";
import { ReactComponent as SettingIcon } from "~/assets/icons/setting.svg";
import { ReactComponent as MyWalletIcon } from "~/assets/icons/myWallet.svg";
import { ReactComponent as DashboardIcon } from "~/assets/icons/dashboard.svg";
import { ReactComponent as TransactionsIcon } from "~/assets/icons/transactions.svg";

// routes
import config from "~/config";

// Styles
import { StyledMainMenu, StyledMenuWrapper } from "./SideMenu.styled";

interface SideMenuProps {
  notifyPayload: Object | null;
}

const mainMenu = [
  {
    title: "Dashboard",
    icon: DashboardIcon,
    path: config.routes.dashboard,
  },
  {
    title: "My Wallets",
    icon: MyWalletIcon,
    path: config.routes.wallets,
  },
  {
    title: "Transactions",
    icon: TransactionsIcon,
    path: config.routes.transactions,
  },
  {
    title: "Budgets",
    icon: BudgetsIcon,
    path: config.routes.budgets,
  },
  {
    title: "Settings",
    icon: SettingIcon,
    path: config.routes.setting,
  },
];

const SideMenu: FC<SideMenuProps> = ({ notifyPayload }) => {
  return (
    <StyledMenuWrapper>
      <UserInfo notifyPayload={notifyPayload} />
      <StyledMainMenu>
        {mainMenu.map((menuItem) => (
          <MenuItem
            Icon={menuItem.icon}
            label={menuItem.title}
            path={menuItem.path}
          />
        ))}
      </StyledMainMenu>
      <List>
        <MenuItem Icon={HelpIcon} label="Help" path={config.routes.help} />
        <LogoutMenu Icon={LogoutIcon} label="Logout" />
      </List>
    </StyledMenuWrapper>
  );
};

export default SideMenu;
